export const BASE_PRECISION = 14;

export const BIG_INT_PRECISION = BigInt(20);

export const BIG_INT_PRECISION_M = 10n ** BIG_INT_PRECISION;
